<div class="overLay" [ngClass]="{'visible': settingSlide , 'hidden': !settingSlide}" (click)="onToggleSettingSlide('')"></div>
<div class="settingContainer" [ngClass]="{'open': settingSlide, 'closed': !settingSlide}">
    <div class="setting-blocks">
        <div class="setting-block" *ngFor="let item of SettingList" (click)="onToggleSettingSlide(item.value)">
            <div class="setting-block-image">
                <img [src]="'assets/images/common/aesthetics/' + item.iconClass + '.svg'" alt="item.displayLabel" />
            </div>
            <div class="setting-block-name">{{item.displayLabel}}</div>
        </div>
    </div>
</div>